import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from '../../atoms/table/Table';
import ReportTableHeader from '../../molecules/table/ReportTableHeader';
import ReportTableRow from '../../molecules/table/ReportTableRow';
import NoDataTableRow from '../../molecules/table/NoDataTableRow';
const ReportTable = ({ reports }) => {
    const getDataRows = () => {
        if (reports.length === 0) {
            return _jsx(NoDataTableRow, {});
        }
        return (reports.length > 0 &&
            reports.map(report => (_jsx(ReportTableRow, { report: report }, report.id))));
    };
    return (_jsxs(Table, { children: [_jsx(ReportTableHeader, {}), getDataRows()] }));
};
export default ReportTable;
